import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "../styles/NotFound.module.css";
import { FaHome, FaArrowLeft } from "react-icons/fa";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className={styles.notFoundContainer}>
      <div className={styles.content}>
        <div className={styles.errorCode}>404</div>
        <h1 className={styles.title}>Page Not Found</h1>
        <p className={styles.description}>
          We're sorry, but the page you're looking for doesn't exist. It may have been moved or deleted.
        </p>
        
        <div className={styles.actions}>
          <button
            className={styles.homeBtn}
            onClick={() => navigate("/")}
          >
            <FaHome /> Go Home
          </button>
          <button
            className={styles.backBtn}
            onClick={() => navigate(-1)}
          >
            <FaArrowLeft /> Go Back
          </button>
        </div>

        <div className={styles.suggestions}>
          <h3>Quick Links</h3>
          <nav className={styles.quickLinks}>
            <a href="/">Home</a>
            <a href="/about-us">About Us</a>
            <a href="/ministry">Ministries</a>
            <a href="/events">Events</a>
            <a href="/sermons">Sermons</a>
          </nav>
        </div>
      </div>
    </div>
  );
}
